import "../../../css/Buttons/ToggleSwitch.css";


export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  id,
  label,
}) {
  const handleClick = () => {
    if (!disabled) onChange?.(!checked);
  };
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      onChange?.(!checked);
    }
  };

  return (
    <div className="aml-switch-wrap">
      <button
        type="button"
        id={id}
        className={`aml-switch ${checked ? "is-on" : ""} ${
          disabled ? "is-disabled" : ""
        }`}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <span className="aml-switch__track" />
        <span className="aml-switch__thumb" />
      </button>
      {label ? (
        <div htmlFor={id} className="AML-Text-Input">
          {label}
        </div>
      ) : null}
    </div>
  );
}
